var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero flex"},[_c('div',{staticClass:"hero-body flex_block"},[_c('div',{staticClass:"container has-text-centered flex "},[_c('IconLoader',{staticClass:"icon_loader"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }